<template>
    <div style="width:100%">
        <v-system-bar height="60" lights-out v-if="showTimeLeft" class="justify-center font-weight-bold title" v-text="`${this.timeLeft}`"></v-system-bar>
        <iframe :src="virtualRoomUrl" :name="roomToken" allow="camera 'src';microphone 'src'" frameborder="0" scroll="auto"></iframe>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import Banner from '@/components/pageBanner';
    import * as signalR from '@microsoft/signalr'
    
    export default {
        name: 'virtualroom',
        data: () => ({
            virtualRoomUrl: '',
            roomToken: '',
            timeLeft: '',
            startTime: null,
            endTime: null,
            showTimeLeft: false,
            loading: true
        }),
        computed: {
            ...mapGetters(['user','type'])
        },
        mounted() {
            this.fetchVirtualroom()           
        },
        created() {
            setInterval(this.calculateTimeLeft, 60000);
        },
        methods: {
            calculateTimeLeft(){
                var now = new Date();
                var startDate = new Date(this.startTime);
                var endDate = new Date(this.endTime);

                const diffMs = Math.abs(now - endDate);
                    
                // var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
                var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes

                if(diffMins < 10)
                    diffMins = '0' + diffMins;
                
                let timeLabel = endDate < now ? 'Extended Time' : 'Time left'
                // this.timeLeft = `${timeLabel}: ${diffHrs}:${diffMins} minutes`
                this.timeLeft = `${timeLabel}: ${diffMins} minutes`

                if(startDate <= now)
                    this.showTimeLeft = true
                else
                    this.showTimeLeft = false 

            },
            async fetchVirtualroom() {
                let timeslotId = this.$route.params.timeslotId
                 await this.axios.get('/Virtualroom/StartVirtualClass', {
                    params: {
                        timeslot: timeslotId,
                        user: this.user.id
                    }
                })
                .then(response => {
                    this.virtualRoomUrl = response.data.virtualRoomData.url
                    this.roomToken = response.data.virtualRoomData.roomToken
                    this.connectToSignalR()
                    this.endTime = response.data.endTime;
                    this.startTime = response.data.startTime;
                    this.calculateTimeLeft();
                    this.loading = false
                })
                .catch(error => { console.log(error) })
            },
            connectToSignalR(){
                var connection = new signalR.HubConnectionBuilder().withUrl(`${process.env.VUE_APP_BASE_URL}classHub`).build();
                connection.start().then(function () {
                    console.log("Connection Started!");
                }).catch(function (err) {
                    console.log("error");
                });
                connection.on(this.roomToken, (response) => {
                    console.log("class ended!");
                    if(response == "ClassEnd" && this.type == "tutor"){
                        this.$router.push({ name: 'tutorSessions' });
                    }
                    else (response == "ClassEnd" && this.type == "student" || this.type == "parent")
                    {
                        this.$router.push(`/${this.$i18n.locale}/student/rate-session/${this.$route.params.timeslotId}`)
                    }
                }); 
            }
        }
    }
</script>

<style lang="scss" scoped>
iframe{
    width: 100%;
    height: calc(100vh - 63px);
    min-height: 500px;
}
</style>